import React from 'react';
import upiQr from '../images/upi-qr.jpeg';

// Shared payment-enrollment modal (QR + UPI copy + name/email/UTR/screenshot form),
// used for every paid program on the site so the flow stays identical everywhere.
const inputStyle = {
  width: '100%', padding: '14px 16px', marginBottom: 16,
  background: 'var(--bg2)', border: '1px solid var(--border)',
  borderRadius: 8, color: 'var(--text)', fontSize: 14,
  outline: 'none', transition: 'border 0.2s', fontFamily: 'inherit',
};

const EnrollModal = ({
  program, user, onClose, onLogin,
  formData, onChange, onFileChange,
  upiCopied, onCopyUpi,
  error, loading, onSubmit,
}) => (
  <div className="modal-overlay" onClick={onClose}>
    <div className="modal-content" onClick={e => e.stopPropagation()}>
      <button className="close-btn" onClick={onClose}>✕</button>

      {!user && (
        <div className="login-banner">
          <span className="login-banner-text">🔒 Please login or sign up to enroll in {program.title}.</span>
          <button type="button" className="login-banner-btn" onClick={onLogin}>Login / Sign Up →</button>
        </div>
      )}

      <div className="modal-columns">
        <div className="modal-left">
          <img src={program.image} alt={program.title} className="modal-course-img" />
          <h2 style={{ fontSize: 24, fontWeight: 800, marginBottom: 12 }}>{program.title}</h2>
          <p style={{ color: 'var(--muted)', fontSize: 15, marginBottom: 32, lineHeight: 1.6 }}>{program.desc}</p>

          <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 12 }}>Step 1: Pay {program.price}</h3>
          <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: 20 }}>Scan the QR code below and save the payment screenshot.</p>

          <div className="qr-box">
            <img src={upiQr} alt="UPI QR Code" className="qr-img" />
            <button type="button" className="upi-tag" onClick={onCopyUpi}>
              <span className="upi-tag-label">UPI ID {upiCopied ? '· Copied!' : '· Tap to Copy'}</span>
              <span className="upi-tag-value">yeeswanthlatha-1@okaxis</span>
            </button>
          </div>

          <p className="contact-note">
            Any doubts? Call / WhatsApp <a href="tel:6381253611">6381253611</a>
          </p>
        </div>

        <div className="modal-right">
          <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 24 }}>Step 2: Submit Details</h3>

          {error && <div style={{ background: '#FEE2E2', color: '#DC2626', padding: '12px 16px', borderRadius: 8, marginBottom: 24, fontSize: 14, fontWeight: 500 }}>{error}</div>}

          <form onSubmit={onSubmit}>
            <fieldset disabled={!user || loading} style={{ border: 'none', padding: 0, margin: 0, opacity: !user ? 0.5 : 1 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#374151' }}>Full Name</label>
              <input type="text" name="name" required placeholder="Your Name" value={formData.name} onChange={onChange} style={inputStyle} />

              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#374151' }}>Email Address</label>
              <input type="email" name="email" required placeholder="name@example.com" value={formData.email} onChange={onChange} style={inputStyle} />

              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#374151' }}>UPI Transaction ID / UTR</label>
              <input type="text" name="transactionId" required placeholder="e.g., 312345678901" value={formData.transactionId} onChange={onChange} style={inputStyle} />

              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#374151' }}>Payment Screenshot</label>
              <input type="file" accept="image/*" required onChange={onFileChange} style={{ ...inputStyle, padding: '10px 16px', background: 'transparent' }} />

              <button type="submit" disabled={loading || !user} style={{
                width: '100%', padding: '16px', marginTop: 8,
                background: 'var(--v1)', color: '#FFF', border: 'none', borderRadius: 8,
                fontSize: 15, fontWeight: 600, cursor: (loading || !user) ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1, transition: 'background 0.2s',
              }}>
                {loading ? 'Submitting...' : !user ? 'Login Required to Enroll' : 'Submit & Enroll'}
              </button>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
);

export default EnrollModal;
